import { UserGroupResponse, UserGroupsResponse } from '@answerr/types';
import http from '../utils/http-common';
import { CreateUserGroupInput, UpdateUserGroupInput } from '../components/main/user-groups/types';

const createUserGroup = (data: CreateUserGroupInput) => {
  return http.post<UserGroupResponse>('/user-group/create', data);
};

const getAllUserGroups = () => {
  return http.post<UserGroupsResponse>('/user-group/get-user-groups', {});
};

const updateUserGroup = (data: UpdateUserGroupInput) => {
  return http.post<UserGroupResponse>('/user-group/update', data);
};


const UserGroupService = {
  createUserGroup,
  getAllUserGroups,
  updateUserGroup,
};

export default UserGroupService;